export const DEFAULT_TABLE_ROW_HEIGHT = 50.375;